<template>
  <div class="x_box">
    <ol class="breadcrumb x_breadcrumb">
      <li class="breadcrumb-item active" aria-current="page">
        របាយការណ៍លម្អិតអំពីការលក់ / SALE INVOICE DETAIL REPORT
      </li>
    </ol>
    <div class="x_header">
      <button
        type="button"
        class="btn btn-outline-primary btn-sm no-bor"
        @click="$router.go(-1)"
      >
        <i class="fa fa-arrow-circle-o-left"></i> {{ $t("back") }}
      </button>
      <button
        type="button"
        class="btn btn-outline-primary btn-sm no-bor"
        @click="onPrint"
      >
        <i class="fa fa-print" aria-hidden="true"></i>
        {{ $t("print") }}
      </button>
      <button
        type="button"
        class="btn btn-outline-primary btn-sm no-bor"
        @click="exportExcel"
      >
        <i class="fa fa-file-excel-o" aria-hidden="true"></i>
        {{ $t("export_excel") }}
      </button>
    </div>
    <div class="x_body">
      <div class="card x_card">
        <div class="card-body">
          <div class="d-flex" style="gap: 8px">
            <div>
              <div class="form-group">
                <label class="control-label blue">{{ $t("filter_type") }}</label>
                <select
                  class="form-control form-control-sm px-3"
                  v-model="query.FilterType"
                >
                  <option v-for="ret in $filterDateTypes()" :key="ret.id" :value="ret.id">
                    {{ $t(ret.lang) }}
                  </option>
                </select>
              </div>
            </div>
            <div v-if="query.FilterType == 3">
              <div class="form-group">
                <label class="control-label blue">{{ $t("from_date") }}</label
                ><br />
                <date-picker
                  v-model="query.FromDate"
                  value-type="format"
                  format="DD-MM-YYYY"
                  type="date"
                ></date-picker>
              </div>
            </div>
            <div v-if="query.FilterType == 3">
              <div class="form-group">
                <label class="control-label blue">{{ $t("to_date") }}</label>
                <br />
                <date-picker
                  v-model="query.ToDate"
                  value-type="format"
                  format="DD-MM-YYYY"
                  type="date"
                ></date-picker>
              </div>
            </div>
            <!-- <div>
              <div class="form-group">
                <label class="control-label blue">{{ $t("customer") }}</label>
                <CustomerDropdown
                  :is-all="true"
                  :place="$t('all')"
                  @select="customerChange"
                ></CustomerDropdown>
              </div>
            </div> -->
            <div>
              <div class="form-group">
                <label class="control-label blue">&nbsp;</label>
                <div>
                  <button type="button" class="btn btn-default btn-sm" @click="toList">
                    <i class="fa fa-search" aria-hidden="true"></i> {{ $t("search") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <table class="table table-bordered table-sm table-striped no-bor">
            <thead class="table-primary">
              <tr class="text-center">
                <th class="text-cener">
                  <!-- ល.រ<br/> -->
                  Date
                </th>
                <th class="text-cener" style="width: 125px">
                  <!-- លេខវិក្កយបត្រ<br/> -->
                  Invoice No.
                </th>
                <th class="text-cener">
                  <!-- ឈ្មោះអតិថិជន<br/> -->
                  Name
                </th>
                <th class="text-cener">
                  <!-- ឈ្មោះអតិថិជន<br/> -->
                  Code
                </th>
                <th class="text-cener">
                  <!-- បរិយាយទំនិញ ឬសេវាកម្ម<br/> -->
                  ItemName
                </th>
                <th class="text-cener" style="width: 50px">
                  <!-- បរិមាណ<br/> -->
                  Qty
                </th>
                <th class="text-cener">
                  <!-- តម្លៃ<br/> -->
                  Price
                </th>
                <th class="text-cener">Amount</th>
                <th class="text-cener">VAT / Sales Tax</th>
                <th class="text-cener">
                  <!-- អត្រាប្តូប្រាក់<br/> -->
                  Exchange Rate
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(ret, index) in records" :key="index">
                <td class="text-center">{{ $format(ret.Date, "DD/MM/YYYY") }}</td>
                <td>{{ ret.Num }}</td>
                <td>{{ ret.CustomerName }}</td>
                <!-- <td>{{ ret.VatTin }}-{{ ret.TinHead }}</td> -->
                <td>{{ ret.ItemCode }}</td>
                <td>{{ ret.ItemName }}</td>
                <td class="text-center">{{ ret.Quantity }}</td>
                <td class="text-right">{{ $number(ret.Price, "0.00000") }}</td>
                <td class="text-right">
                  {{ $money(ret.Quantity * ret.Price + ret.TaxLine) }}
                </td>
                <td class="text-center">{{ ret.TaxLine == 0 ? "No" : "Yes" }}</td>
                <td class="text-right">{{ $number(ret.ExchangeRate) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
export default {
  components: { DatePicker },
  data() {
    return {
      query: {
        CustomerId: "",
        FromDate: this.$format(this.$startOfMonth(), 'DD-MM-YYYY'),
        ToDate: this.$format(this.$endOfMonth(), 'DD-MM-YYYY'),
        FilterType: 3,
      },
      records: [],
      summary: {
        TaxAmt: 0,
        UntaxAmt: 0,
        IncTaxAmt: 0,
        TotalAmt: 0,
        TotalAmtRiel: 0,
      },
    };
  },
  created() {
    this.query.CompanyId = this.$store.state.company.Id;
    this.toList();
  },
  methods: {
    async toList() {
      if(this.query.FromDate != '') this.query.FromDate = this.$formatFromTo(this.query.FromDate, 'DD-MM-YYYY', 'YYYY-MM-DD');  
      if(this.query.ToDate != '') this.query.ToDate = this.$formatFromTo(this.query.ToDate, 'DD-MM-YYYY', 'YYYY-MM-DD');        
      var loading = this.$loading.show();
      await this.$api()
        .post("invoice/report-invoice-detail", this.query)
        .then((res) => {
          if (this.$isValid(res)) {
            this.records = res.data.Json.Invoices;
            this.calculate();
          }
        })
        .finally(() => {
          loading.hide();
        });
      if(this.query.FromDate != '') this.query.FromDate = this.$formatFromTo(this.query.FromDate, 'YYYY-MM-DD', 'DD-MM-YYYY');  
      if(this.query.ToDate != '') this.query.ToDate = this.$formatFromTo(this.query.ToDate, 'YYYY-MM-DD', 'DD-MM-YYYY');  
    },
    exportExcel() {
      if(this.query.FromDate != '') this.query.FromDate = this.$formatFromTo(this.query.FromDate, 'DD-MM-YYYY', 'YYYY-MM-DD');  
      if(this.query.ToDate != '') this.query.ToDate = this.$formatFromTo(this.query.ToDate, 'DD-MM-YYYY', 'YYYY-MM-DD');        
      let link = `${this.$base()}export/invoices-detail-list-excel?fd=${this.query.FromDate}&td=${this.query.ToDate}&cs=${this.query.CustomerId}&ft=${this.query.FilterType}&cid=${this.query.CompanyId}`;      
      if(this.query.FromDate != '') this.query.FromDate = this.$formatFromTo(this.query.FromDate, 'YYYY-MM-DD', 'DD-MM-YYYY');  
      if(this.query.ToDate != '') this.query.ToDate = this.$formatFromTo(this.query.ToDate, 'YYYY-MM-DD', 'DD-MM-YYYY');  
      window.open(link, "_blank");
    },
    onPrint() {
      if(this.query.FromDate != '') this.query.FromDate = this.$formatFromTo(this.query.FromDate, 'DD-MM-YYYY', 'YYYY-MM-DD');  
      if(this.query.ToDate != '') this.query.ToDate = this.$formatFromTo(this.query.ToDate, 'DD-MM-YYYY', 'YYYY-MM-DD');        
      let query = {
        fd: this.query.FromDate,
        td: this.query.ToDate,
        cs: this.query.CustomerId,
        ft: this.query.FilterType,
      };
      let link = this.$router.resolve({
        path: "/print-sale-invoice-detail-list",
        query: query,
      });
      if(this.query.FromDate != '') this.query.FromDate = this.$formatFromTo(this.query.FromDate, 'YYYY-MM-DD', 'DD-MM-YYYY');  
      if(this.query.ToDate != '') this.query.ToDate = this.$formatFromTo(this.query.ToDate, 'YYYY-MM-DD', 'DD-MM-YYYY');  
      window.open(link.href, "_blank");
    },
    customerChange(e) {
      this.query.CustomerId = e.Id;
      this.toList();
    },
    calculate() {
      let untax = 0;
      let tax = 0;
      let inctax = 0;
      let total = 0;
      let totalRiel = 0;
      this.records.forEach((el) => {
        untax += el.Quantity * el.Price;
        tax += el.TaxAmount;
        inctax += el.Quantity * el.Price + el.TaxLine;
        total += el.SubTotal;
        totalRiel += el.SubTotal * el.ExchangeRate;
      });
      this.summary.UntaxAmt = untax;
      this.summary.TaxAmt = tax;
      this.summary.IncTaxAmt = inctax;
      this.summary.TotalAmt = total;
      this.summary.TotalAmtRiel = totalRiel;
    },
  },
};
</script>
